import React from 'react'
import intl from 'react-intl-universal'
import { Input, Table, Button } from 'reactstrap'
import { PicklistItem } from '~/types'

interface Props {
  data: PicklistItem[]
  sortOrder: { sortKey: string; reversed: boolean }
  onSort: (sortKey: keyof Pick<PicklistItem, 'id' | 'text'>) => void
  onEdit: (subtype: PicklistItem) => void
  onDelete: (subtype: PicklistItem) => void
  onToggleActive: (subtype: PicklistItem) => void
  onToggleDefault: (subtype: PicklistItem) => void
}

export default function SubtypeTable(props: Props) {
  return (
    <Table data-testid="subtype-list-table" size="sm">
      <thead>
        <tr>
          <th></th>
          <th>
            <Button
              className="list-filter"
              // currently ordered by name ? flip the sort : keep it
              onClick={() => props.onSort('text')}
            >
              {intl.get('LinkListSubtypesConfiguration.cardBody.labels.name')}{' '}
              <i
                className={`fa fa-caret-${
                  props.sortOrder.sortKey === 'text' && props.sortOrder.reversed
                    ? 'down'
                    : 'up'
                }`}
              ></i>
            </Button>
          </th>
          <th>
            <Button
              className="list-filter"
              // currently ordered by id ? flip the sort : keep it
              onClick={() => props.onSort('id')}
            >
              {intl.get('LinkListSubtypesConfiguration.cardBody.labels.id')}{' '}
              <i
                className={`fa fa-caret-${
                  props.sortOrder.sortKey === 'id' && props.sortOrder.reversed
                    ? 'down'
                    : 'up'
                }`}
              ></i>
            </Button>
          </th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {props.data.map((subtype, i) => {
          return (
            <tr key={i} data-testid={`${subtype.id}-tablerow`}>
              <td className="active-subtype-col">
                <Input
                  data-testid={`${subtype.id}-checkbox`}
                  type="checkbox"
                  checked={subtype.active}
                  onChange={() => props.onToggleActive(subtype)}
                />
              </td>
              <td>{subtype.text}</td>
              <td>{subtype.id}</td>
              <td className="default-subtype-col icon-col">
                <Button
                  data-testid={`${subtype.id}-default`}
                  value={subtype.id}
                  onClick={() => {
                    props.onToggleDefault(subtype)
                  }}
                >
                  <i
                    className={`fa fa-star${
                      subtype.default ? ' text-primary' : '-o'
                    }`}
                  ></i>
                </Button>
              </td>
              <td className="delete-subtype-col icon-col">
                <Button
                  data-testid={`${subtype.id}-delete`}
                  onClick={() => {
                    props.onDelete(subtype)
                  }}
                >
                  <i className="fa fa-trash-o c-brand-danger"></i>
                </Button>
              </td>
              <td className="edit-subtype-col icon-col">
                <Button
                  data-testid={`${subtype.id}-edit`}
                  onClick={() => props.onEdit(subtype)}
                >
                  <i className="fa fa-cog"></i>
                </Button>
              </td>
            </tr>
          )
        })}
      </tbody>
    </Table>
  )
}
